import './index.scss';
import 'components/modals/guide_not_premium_user_modal';
import { handleApiError } from 'utils/api_error_handler';

(function ($) {
  const $guidesShowPage = $('.q-guides-page-show');
  const $addGuideBtn = $('.js-btn-add-guide', $guidesShowPage);

  $addGuideBtn.on('click', () => {
    let guideId = $guidesShowPage.data().guideId;
    let guideName = $guidesShowPage.data().guideName;

    Thor.UserGuide.create(
      {},
      {
        data: { guide_id: guideId }
      }
    )
      .then(() => {
        toastr.success(
          `O Guia ${guideName} foi adicionado aos seus guias com sucesso!`
        );
        $addGuideBtn.attr('disabled', true);
        $addGuideBtn.text('Guia adicionado!');
      })
      .catch(response => {
        handleApiError(
          'Ops! Algo deu errado ao salvar este Guia de Estudos. Tente novamente mais tarde ou entre em contato.',
          response
        );
      });
  });
})(jQuery);
